import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Tooltip } from "flowbite-react";

import { CoworkerForm, useCoworkerForm } from "../components/coworker_form";
import { Popup } from "../../../components/pop-up";
import { Reset2FA } from "../components/reset2fa";
import { ResendOnboardingLink } from "../components/resend_onboarding_link";

import { EDITCOWORKER_RESPONSE } from "../../../constants/action_types";

import * as actions from "../../../actions";
import { FlatButton, IconButton } from "../../../components/buttons";
import { ACL } from "../../../components/acl";
import { SUPERADMIN, FINANCEADMIN } from "../../../constants/roles";

function Details({ coworkerDetails }) {
  const dispatch = useDispatch();

  const coworkerUpdated = useSelector(
    (state) => state.coworker.update_response
  );

  const [openModal, setOpenModal] = useState();
  const [editMode, setEditMode] = useState(false);

  useEffect(() => {
    if (coworkerUpdated?.type === EDITCOWORKER_RESPONSE) {
      dispatch(actions.GETCOWORKER_REQ(coworkerDetails));
      setEditMode();
    }
  }, [coworkerUpdated]);

  const coworkerForm = useCoworkerForm(coworkerDetails, "Edit", () => {
    setOpenModal("pop-up");
  });

  const updateCoworker = () => {
    setOpenModal();
    dispatch(actions.EDITCOWORKER_REQ(coworkerForm.values));
  };

  return (
    <div class="h-full mt-3">
      <div class="relative h-full w-full bg-white rounded-lg shadow px-4">
        <div class="p-2">
          <div class="flow-root">
            <div class="-mx-4 -my-2 sm:-mx-6 lg:-mx-8">
              <div class="inline-block min-w-full py-4 align-middle sm:px-6 lg:px-8">
                <div class="mx-auto pb-3 border-b sm:flex sm:items-center sm:justify-between">
                  <h3 class="text-lg font-semibold leading-6 text-gray-900">
                    Coworker Details
                  </h3>
                  <div class="mt-3 sm:ml-4 sm:mt-0">
                    {!editMode && (
                      <div className="flex items-center justify-center space-x-3">
                        <Reset2FA data={coworkerDetails} />
                        {coworkerDetails?.role === "PARTNER" && (
                          <ACL showFor={[SUPERADMIN, FINANCEADMIN]}>
                            <ResendOnboardingLink data={coworkerDetails} />
                          </ACL>
                        )}
                        <ACL showFor={[SUPERADMIN, FINANCEADMIN]}>
                          <Tooltip
                            placement="bottom"
                            content={
                              <p className="whitespace-nowrap">Edit details</p>
                            }
                          >
                            <IconButton onClick={() => setEditMode(true)}>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                                fill="currentColor"
                                class="w-4 h-4"
                              >
                                <path d="M21.731 2.269a2.625 2.625 0 00-3.712 0l-1.157 1.157 3.712 3.712 1.157-1.157a2.625 2.625 0 000-3.712zM19.513 8.199l-3.712-3.712-12.15 12.15a5.25 5.25 0 00-1.32 2.214l-.8 2.685a.75.75 0 00.933.933l2.685-.8a5.25 5.25 0 002.214-1.32L19.513 8.2z" />
                              </svg>
                            </IconButton>
                          </Tooltip>
                        </ACL>
                      </div>
                    )}
                    {editMode && (
                      <div class="flex items-center justify-center space-x-3">
                        <FlatButton
                          className="w-[100px] inline-flex justify-center items-center gap-x-1.5"
                          appearance="secondary"
                          onClick={() => {
                            coworkerForm.resetForm();
                            setEditMode(false);
                          }}
                        >
                          Cancel
                        </FlatButton>
                        <FlatButton
                          className="w-[100px] inline-flex justify-center items-center gap-x-1.5"
                          onClick={() => {
                            coworkerForm.submitForm();
                          }}
                        >
                          Save
                        </FlatButton>
                      </div>
                    )}
                  </div>
                </div>
                <div class="mt-0">
                  <CoworkerForm
                    showProfile={editMode}
                    formik={coworkerForm}
                    mode="Edit"
                    readOnly={!editMode}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Popup
        modalState={[openModal, setOpenModal]}
        onConfirm={updateCoworker}
        content={
          <>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="mx-auto mb-4 h-14 w-14 text-gray-400 dark:text-gray-200"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z"
              />
            </svg>
            <h3 className="mb-5 text-lg font-normal text-gray-500 dark:text-gray-400">
              Are you sure you want to edit details of{" "}
              <b>{coworkerDetails?.fullName}</b>?
            </h3>
          </>
        }
      />
    </div>
  );
}

export default Details;
